import { component } from 'picoapp';

export default component((node) => {
  /**
   * Data + elements
   */
  const btn = node.querySelector('.js-btn');
  const content = node.querySelector('.js-content');

  /**
   * Functions
   */
  const toggle = () => {
    btn.classList.toggle('harmonica-item__button--active');

    if (content.hidden) {
      content.hidden = false;
    } else {
      content.hidden = true;
    }
  };

  const init = () => {
    btn.addEventListener('click', toggle);
  };

  /**
   * Init
   */
  init();
});
